module.exports = __webpack_public_path__ + "static/media/csr_women_empowerment.968f6fd9.JPG";